import type { DocumentLock } from '@ztechapps/common.contract'
import { DocumentLockKeyEnum } from '@ztechapps/common.contract'
import type { UseDocumentLockResult } from '@ztechapps/common.hook'
import { useDocumentLock } from '@ztechapps/common.hook'

export type UseOrderDocumentLock = { value: string; initialValue?: DocumentLock }
export const useOrderDocumentLock = ({ value, initialValue }: UseOrderDocumentLock): UseDocumentLockResult => {
  return useDocumentLock({
    key: DocumentLockKeyEnum.Order,
    value,
    initialValue,
  })
}
